import useGameLikeMutation from '~/features/user/useGameLikeMutation';

const useGameLikeAction = () => {
  const { mutate: handleGameLike } = useGameLikeMutation();

  const handleLikeClick = (id: string, isLiked: boolean) => {
    handleGameLike({
      game_id: Number(id),
      operation: isLiked ? 'unlike' : 'like',
    });
  };

  return {
    handleGameLike,
    handleLikeClick,
  };
};

export default useGameLikeAction;
